import { render, staticRenderFns } from "./FestivalBonusPolicyView.vue?vue&type=template&id=13bda452&"
import script from "./FestivalBonusPolicyView.vue?vue&type=script&lang=js&"
export * from "./FestivalBonusPolicyView.vue?vue&type=script&lang=js&"
import style0 from "./FestivalBonusPolicyView.vue?vue&type=style&index=0&id=13bda452&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports